import { useCallback, useState } from 'react';
import { useParams } from 'react-router';

import { useInvitation } from '../../hooks/invitation';
import { useInvitationChanges } from '../../hooks/invitation-changes';

import { InvitationAsk } from '../invitation-ask';
import { InvitationOutcome } from '../invitation-outcome';
import { LoadFailed } from '../load-failed';

import styles from './style.module.css';

// A clinician's invitation, opened from the email's link, a card on Today or
// Settings (C22). While it is open the patient reads what accepting means and
// accepts or declines; afterwards the page says what happened. An invitation
// that is not open to them — answered, withdrawn, expired or sent to
// another address — reads as no longer open, the same in every case.
export function Invitation() {
  const { invitationId } = useParams();
  const { invitation, error, retry } = useInvitation(invitationId);
  const { respond } = useInvitationChanges();
  const [ outcome, setOutcome ] = useState();

  // The answer decides the page: accepted or declined when it was taken,
  // closed when the invitation stopped being open in the meantime. A failure
  // rejects, for the question to show under its buttons.
  const answer = useCallback(function(accept) {
    return respond({ id: invitationId, accept }).then(function(taken) {
      if (taken === false) {
        setOutcome('closed');

        return;
      }

      if (accept === true) {
        setOutcome('accepted');

        return;
      }

      setOutcome('declined');
    });
  }, [ respond, invitationId ]);

  if (error != null) {
    return <LoadFailed onRetry={ retry }/>;
  }

  if (invitation === undefined) {
    return null;
  }

  let content = <InvitationOutcome outcome='closed'/>;

  if (invitation !== null && outcome == null) {
    content = <InvitationAsk invitation={ invitation } onAnswer={ answer }/>;
  }

  if (invitation !== null && outcome != null) {
    content = <InvitationOutcome outcome={ outcome } clinician={ invitation.clinician }/>;
  }

  return <section className={ styles.page }>{ content }</section>;
}
